(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["burker-early-access"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('burker-ea-countdown')) {
  customElements.define('burker-ea-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end)) { this.hidden = true; return; }
      const update = () => {
        const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const values = [Math.floor(left / 86400), Math.floor(left % 86400 / 3600), Math.floor(left % 3600 / 60), left % 60];
        ['days', 'hours', 'minutes', 'seconds'].forEach((key, index) => {
          const target = this.querySelector('[data-' + key + ']');
          if (target) target.textContent = String(values[index]).padStart(2, '0');
        });
        if (left === 0) clearInterval(this.timer);
      };
      update();
      if (end > Date.now()) this.timer = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
